import useTheme from '@mui/material/styles/useTheme';
import { SVGProps } from 'react';

export const NotFoundImage = (
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>
) => {
  const theme = useTheme();
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_1185_22424)">
        <path
          d="M22.1417 42.2749C25.0036 41.6769 26.5072 37.1292 25.5001 32.1173C24.493 27.1054 21.3566 23.5273 18.4947 24.1253C15.6328 24.7232 14.1292 29.2709 15.1363 34.2828C16.1434 39.2947 19.2798 42.8729 22.1417 42.2749Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M28.3583 46.3446C32.8913 45.3974 35.2724 38.1921 33.6766 30.251C32.0809 22.3099 27.1127 16.6401 22.5797 17.5873C18.0467 18.5344 15.6657 25.7398 17.2614 33.6809C18.8571 41.622 23.8254 47.2917 28.3583 46.3446Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M32.8615 45.5628C37.3944 44.6157 39.7756 37.4103 38.1798 29.4692C36.5841 21.5281 31.6158 15.8584 27.0829 16.8055C22.5499 17.7527 20.1688 24.958 21.7645 32.8991C23.3603 40.8402 28.3285 46.51 32.8615 45.5628Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M68.9416 21.8074L29.7351 29.9995L30.5269 33.9399L69.7334 25.7478L68.9416 21.8074Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M68.3578 38.1458C72.8908 37.1987 75.2719 29.9933 73.6761 22.0522C72.0804 14.1111 67.1122 8.44141 62.5792 9.38855C58.0463 10.3357 55.6652 17.5411 57.2609 25.4822C58.8566 33.4233 63.8249 39.093 68.3578 38.1458Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M72.0659 37.3714C76.5988 36.4242 78.9799 29.2189 77.3842 21.2778C75.7885 13.3367 70.8202 7.66698 66.2873 8.61413C61.7543 9.56128 59.3732 16.7666 60.9689 24.7077C62.5646 32.6488 67.5329 38.3185 72.0659 37.3714Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M72.4723 31.7602C75.3342 31.1622 76.8378 26.6146 75.8307 21.6027C74.8236 16.5908 71.6872 13.0126 68.8253 13.6106C65.9634 14.2086 64.4597 18.7563 65.4668 23.7682C66.474 28.7801 69.6104 32.3582 72.4723 31.7602Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M74.8129 31.27C77.6748 30.672 79.1784 26.1243 78.1713 21.1124C77.1642 16.1005 74.0277 12.5224 71.1658 13.1204C68.3039 13.7184 66.8003 18.2661 67.8074 23.2779C68.8145 28.2898 71.951 31.868 74.8129 31.27Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M155.37 127.271C155.705 130.428 146.838 134 135.564 135.247C124.291 136.494 114.879 134.945 114.544 131.784L113.905 127.938L154.727 123.425L155.366 127.271H155.37Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M134.731 129.488C146.003 128.241 154.961 125.524 154.737 123.42C154.513 121.315 145.193 120.619 133.92 121.866C122.647 123.113 113.69 125.83 113.914 127.934C114.137 130.039 123.458 130.735 134.731 129.488Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M127.387 47.2189L123.76 47.6201L132.031 125.39L135.659 124.989L127.387 47.2189Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M159.121 47.8628L141.374 10.8013C141.055 7.78461 132.077 6.30038 121.324 7.48696C110.571 8.67756 102.114 12.0885 102.438 15.1052L92.8921 55.1834C92.5213 55.8391 92.3596 56.4907 92.4267 57.1343C92.9828 62.3713 108.56 64.9456 127.213 62.8821C145.871 60.8187 160.541 54.9019 159.985 49.6648C159.917 49.0213 159.618 48.4219 159.121 47.8628Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M122.487 18.4182C133.24 17.2289 141.697 13.8174 141.376 10.7984C141.055 7.77935 132.078 6.29604 121.324 7.48531C110.571 8.67458 102.114 12.0861 102.435 15.1051C102.757 18.1241 111.734 19.6074 122.487 18.4182Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M128.614 64.0843L126.531 69.08L126.204 64.0843L128.614 63.2114V64.0843Z"
          fill={theme.palette.grey[900]}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M24.8081 85.5761L24.8045 85.5745C22.858 84.6966 20.5821 85.5939 19.7212 87.5788L1.55875 129.452C0.697805 131.437 1.57782 133.757 3.52432 134.635L3.52793 134.637C5.47442 135.515 7.75029 134.617 8.61124 132.633L26.7736 90.7597C27.6346 88.7748 26.7546 86.454 24.8081 85.5761Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M70.399 101.205L70.3951 101.205C68.3024 100.809 66.2912 102.218 65.903 104.352L57.7128 149.369C57.3246 151.503 58.7063 153.554 60.799 153.95L60.8029 153.951C62.8956 154.347 64.9068 152.938 65.295 150.804L73.4852 105.786C73.8734 103.652 72.4917 101.601 70.399 101.205Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M50.3796 82.7378L50.3758 82.7367C48.3372 82.113 46.1888 83.2926 45.5771 85.3715L32.6745 129.226C32.0629 131.305 33.2197 133.496 35.2583 134.12L35.2621 134.121C37.3007 134.744 39.4492 133.565 40.0608 131.486L52.9634 87.6312C53.5751 85.5523 52.4182 83.3615 50.3796 82.7378Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M88.251 101.244C85.6397 110.117 65.7278 111.863 43.7765 105.145C21.8252 98.4282 6.14576 85.7901 8.75703 76.9209"
          fill={theme.palette.background.default}
        />
        <path
          d="M88.251 101.244C85.6397 110.117 65.7278 111.863 43.7765 105.145C21.8252 98.4282 6.14576 85.7901 8.75703 76.9209"
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M88.249 101.233C90.3361 94.1387 74.2331 82.9439 52.2819 76.2284C30.3307 69.5128 10.8438 69.8196 8.75663 76.9136C6.66949 84.0075 22.7725 95.2023 44.7237 101.918C66.6749 108.633 86.1618 108.327 88.249 101.233Z"
          fill={theme.palette.background.default}
          stroke={theme.palette.grey[900]}
          stroke-width="1.18336"
          stroke-miterlimit="10"
        />
        <path
          d="M47.2713 106.952L38.1042 110.745L40.1041 103.948L47.2713 106.952Z"
          fill={theme.palette.grey[900]}
          stroke={theme.palette.grey[900]}
          stroke-width="0.986129"
          stroke-miterlimit="10"
        />
        <path
          d="M15.8293 96.5138L24.1641 97.0166L17.9121 92.5156L15.8293 96.5138Z"
          fill={theme.palette.grey[900]}
          stroke={theme.palette.grey[900]}
          stroke-width="0.986129"
          stroke-miterlimit="10"
        />
        <path
          d="M64.9469 109.522L64.2092 113.56L72.7886 109.522H64.9469Z"
          fill={theme.palette.grey[900]}
          stroke={theme.palette.grey[900]}
          stroke-width="0.986129"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1185_22424">
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
